var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopicsNoTopic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 236,
    height: 186,
    viewBox: "0 0 236 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4234",
    x: 0,
    y: 0,
    width: 236,
    height: 174,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4295",
    x: 10,
    y: 27,
    width: 216,
    height: 159,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4280",
    x: 81,
    y: 35,
    width: 76,
    height: 50,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Topic_not_found",
    "data-name": "Topic not found",
    transform: "translate(-541 -3546)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 541, 3546)",
    filter: "url(#Rectangle_4234)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4234-2",
    "data-name": "Rectangle 4234",
    width: 218,
    height: 156,
    rx: 5,
    transform: "translate(9 6)",
    fill: "#e6ebf4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(560 3558)",
    fill: "#769eb0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(573 3558)",
    fill: "#769eb0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    transform: "translate(585 3558)",
    fill: "#769eb0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 541, 3546)",
    filter: "url(#Rectangle_4295)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4295-2",
    "data-name": "Rectangle 4295",
    width: 198,
    height: 141,
    rx: 5,
    transform: "translate(19 33)",
    fill: "#fefefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6575",
    "data-name": "Group 6575",
    transform: "translate(6044 2512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_371",
    "data-name": "Line 371",
    d: "M-511,1306h-8c-6,0-6.067,6.044-6.067,6.044v17.328",
    transform: "translate(-4899.933 -214)",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3606",
    "data-name": "Path 3606",
    d: "M-486,1356v-12.5a13.5,13.5,0,0,0-13.5-13.5h-23a13.5,13.5,0,0,0-13.5,13.5V1356",
    transform: "translate(-4905 -214)",
    fill: "none",
    stroke: "#d8e4f9",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3607",
    "data-name": "Path 3607",
    d: "M-514,1340.355v-4.979a5.677,5.677,0,0,0-5.94-5.377h-10.12a5.677,5.677,0,0,0-5.94,5.377v4.979",
    transform: "translate(-4916 -160.355)",
    fill: "none",
    stroke: "#d8e4f9",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3608",
    "data-name": "Path 3608",
    d: "M-514,1340.355v-4.979a5.677,5.677,0,0,0-5.94-5.377h-10.12a5.677,5.677,0,0,0-5.94,5.377v4.979",
    transform: "translate(-4866 -160.355)",
    fill: "none",
    stroke: "#d8e4f9",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_372",
    "data-name": "Line 372",
    y2: 12.442,
    transform: "translate(-5441 1158.058)",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_373",
    "data-name": "Line 373",
    y2: 12.442,
    transform: "translate(-5391 1158.058)",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_41",
    "data-name": "Subtraction 41",
    d: "M0,10.033V0L5.016,5.016,0,10.031Z",
    transform: "translate(721.017 3649.796) rotate(90)",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4286",
    "data-name": "Rectangle 4286",
    width: 32,
    height: 10,
    rx: 3,
    transform: "translate(637 3656)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4289",
    "data-name": "Rectangle 4289",
    width: 32,
    height: 10,
    rx: 3,
    transform: "translate(587 3656)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4303",
    "data-name": "Rectangle 4303",
    width: 10,
    height: 10,
    rx: 3,
    transform: "translate(587 3694)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4305",
    "data-name": "Rectangle 4305",
    width: 10,
    height: 10,
    rx: 3,
    transform: "translate(637 3694)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4304",
    "data-name": "Rectangle 4304",
    width: 10,
    height: 10,
    rx: 3,
    transform: "translate(609 3694)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4306",
    "data-name": "Rectangle 4306",
    width: 10,
    height: 10,
    rx: 3,
    transform: "translate(659 3694)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3604",
    "data-name": "Path 3604",
    d: "M-375.07,1304h9.57a16.5,16.5,0,0,1,16.5,16.5v31.967",
    transform: "translate(1065 2301)",
    fill: "none",
    stroke: "#d8e4f9",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 541, 3546)",
    filter: "url(#Rectangle_4280)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4280-2",
    "data-name": "Rectangle 4280",
    width: 58,
    height: 32,
    rx: 5,
    transform: "translate(90 41)",
    fill: "#7e9dae"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4290",
    "data-name": "Rectangle 4290",
    width: 23,
    height: 3,
    rx: 1.5,
    transform: "translate(648 3598)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4291",
    "data-name": "Rectangle 4291",
    width: 36,
    height: 3,
    rx: 1.5,
    transform: "translate(642 3604)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6576",
    "data-name": "Group 6576",
    transform: "translate(6044 2508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_40",
    "data-name": "Subtraction 40",
    d: "M0,10.033V0L5.016,5.016,0,10.031Z",
    transform: "translate(-5435.983 1141.796) rotate(90)",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_48",
    "data-name": "Subtraction 48",
    d: "M0,10.033V0L5.016,5.016,0,10.031Z",
    transform: "translate(-5446.983 1179.984) rotate(90)",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_51",
    "data-name": "Subtraction 51",
    d: "M0,10.033V0L5.016,5.016,0,10.031Z",
    transform: "translate(-5397 1179.984) rotate(90)",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_49",
    "data-name": "Subtraction 49",
    d: "M0,10.033V0L5.016,5.016,0,10.031Z",
    transform: "translate(-5424.983 1179.984) rotate(90)",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_50",
    "data-name": "Subtraction 50",
    d: "M0,10.033V0L5.016,5.016,0,10.031Z",
    transform: "translate(-5375 1179.984) rotate(90)",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_42",
    "data-name": "Subtraction 42",
    d: "M0,10.033V0L5.016,5.016,0,10.031Z",
    transform: "translate(-5385.983 1141.796) rotate(90)",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_226",
    "data-name": "Ellipse 226",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(-5438.5 1155.5) rotate(90)",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_232",
    "data-name": "Ellipse 232",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(-5410.5 1093.5) rotate(90)",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_231",
    "data-name": "Ellipse 231",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(-5388.5 1155.5) rotate(90)",
    fill: "#d8e4f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6709",
    "data-name": "Group 6709",
    transform: "translate(453.793 -1965.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6706",
    "data-name": "Group 6706",
    transform: "translate(242 5627.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3609",
    "data-name": "Path 3609",
    d: "M280.393,5667.371H244.019a2.021,2.021,0,0,1-1.807-2.924l18.187-36.375a2.1,2.1,0,0,1,3.615,0l18.187,36.375a2.021,2.021,0,0,1-1.809,2.924Zm-33.1-4.042h29.833l-14.918-29.836Z",
    transform: "translate(-242 -5627.045)",
    fill: "#cd4e49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6707",
    "data-name": "Group 6707",
    transform: "translate(260.186 5643.121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5378",
    "data-name": "Rectangle 5378",
    width: 4.042,
    height: 12.125,
    fill: "#cd4e49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6708",
    "data-name": "Group 6708",
    transform: "translate(259.681 5656.762)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236",
    "data-name": "Ellipse 236",
    cx: 2.526,
    cy: 2.526,
    r: 2.526,
    fill: "#cd4e49"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicsNoTopic);
export default __webpack_public_path__ + "static/media/topics-no-topic.196652f803ec1b3f34bfe1aadd00a6f7.svg";
export { ForwardRef as ReactComponent };